import db from '../../db';
import { getCurrentDayString } from '../../time';
import { getImputationsByDay } from '../imputations/imputationsActions'
import { deleteAllImputationByDay } from '../imputations/imputationsEditionActions'
import { FETCH_ACTIVE_DAY, VALIDATE_DAY_SEND_DATA_SUCCESS, SET_ALL_DAYS } from './dayConstants'
import { createDayInDb } from './dayEditionActions'

export function validateDaySendDataHasErrored(bool) {
    return {
        type: 'VALIDATE_DAY_SEND_DATA_ERRORED',
        hasErrored: bool
    };
}

export function validateDaySendDataIsLoading(bool) {
    return {
        type: 'VALIDATE_DAY_SEND_DATA_IS_LOADING',
        isLoading: bool
    };
}

export function validateDaySendDataSuccess(data) {
    return {
        type: VALIDATE_DAY_SEND_DATA_SUCCESS,
        payload: data
    };
}

export function fetchActiveDayAction(day, isValidationAuthorized, isModificationAuthorized) {
    return {
        type: FETCH_ACTIVE_DAY,
        payload: day,
        isValidationAuthorized: isValidationAuthorized,
        isModificationAuthorized: isModificationAuthorized
    }
}

function setAllDaysActions(allDays) {
    return {
        type: SET_ALL_DAYS,
        allDays: allDays,
    }
}

//récupération de l'item en cours, si présent (si plusieurs items en cours, une erreur est survenue donc on supprime tout)
export function fillCurrentState(data) {
    return (dispatch) => {
        return new Promise((resolve) => {
            let imputation = data;
            if (imputation.length === 0) {
                return resolve(null)
            } else if (imputation.length === 1) {
                return resolve(imputation[0]);
            } else {
                dispatch(deleteAllImputationByDay(imputation[0].day_id));
                return resolve(null);
            }
        })
    }
}

export async function getAllDays() {
    return await db.Day.toArray(async (data) => data);
}

export async function is_day_started(day_id) {
    let imputations = await getImputationsByDay(day_id);

    if (!imputations)
        return false;

    return imputations.length > 0;
}

export async function is_validation_authorized(day) {
    if (!day) {
        return false;
    }

    return await db.transaction("r?", db.Day, db.Imputation, async () => {
        return await db.Day.where('date').below(day.date).toArray(async (coll) => {
            let ok_to_validate = true;
            for (let i = 0; i < coll.length; i++) {
                if (coll[i].validation === false && (await is_day_started(coll[i].id))) {
                    ok_to_validate = false;
                }
            }

            return ok_to_validate;
        }).catch((e) => {
            console.error("dayActions - is_validation_authorized");
            throw e;
        });
    }).catch((e) => {
        console.error("dayActions - is_validation_authorized");
        throw e;
    });
}

export async function is_modification_authorized(day) {
    if (!day) {
        return false;
    }

    return await db.transaction("r?", db.Day, db.Imputation, async () => {

        let current_day_started = await is_day_started(day.id);
        if (current_day_started && day.validation === false) {
            return true;
        }

        let ok_to_modify = await db.Day.where('date').aboveOrEqual(day.date).toArray(async (coll) => {
            for (let i = 0; i < coll.length; i++) {
                if (coll[i].validation === true) {
                    return false;
                }
            }
            return true;
        }).catch((e) => {
            console.error("Erreur : dayActions - is_modification_authorized 1 ")
            throw e;
        });

        if (ok_to_modify) {
            ok_to_modify = await db.Day.toArray(async (coll) => {
                let ended_counter = 0;
                for (let i = 0; i < coll.length; i++) {
                    let started_day = await is_day_started(coll[i].id);
                    if (started_day && coll[i].date !== day.date && !coll[i].validation) {
                        ended_counter++;
                    }
                }

                return (ended_counter < 2);
            }).catch((e) => {
                console.error("dayActions - is_modification_authorized 2 ");
                throw e;
            });
        }

        return ok_to_modify;
    }).catch((e) => {
        console.error("Erreur : dayActions - is_modification_authorized")
        throw e;
    });
}

export function refreshAllDaysList() {
    return (dispatch) => {
        db.Day.toArray((days) => {
            dispatch(setAllDaysActions(days))
        });
    }
}

export function getActiveDay(userId) {
    return (dispatch) => {
        db.transaction("r?", db.Day, db.Imputation, db.User, async () => {
            await db.Day.where({ user_id: userId }).toArray(async (coll) => {
                let day = undefined;
                for (let i = 0; i < coll.length; i++) {
                    if (coll[i].active) {
                        day = coll[i];
                    }
                }

                return day;
            }).catch((e) => {
                console.error("Erreur : dayActions - getActiveDay")
                throw e;
            });
        }).then(async (day) => {
            if (day === undefined) {
                let today = await createOrGetDayByDate(userId, getCurrentDayString());
                day = today.day;
            }

            let isValidationAuthorized = await is_validation_authorized(day);
            let isModificationAuthorized = await is_modification_authorized(day);
            dispatch(fetchActiveDayAction(day, isValidationAuthorized, isModificationAuthorized));
        }).catch((e) => {
            console.error("Erreur : dayActions - getActiveDay")
            throw e;
        });
    }
}


export async function createOrGetDayByDate(_user_id, _date, createDayIfNeeded = false) {
    if (_date === null)
        return null;

    return await db.transaction("rw?", db.Day, db.User, async () => {
        return await db.Day.where({ user_id: _user_id, date: _date }).toArray(async (coll) => {
            if (coll.length === 0) {
                if (createDayIfNeeded) {
                    return await createDayInDb({
                        user_id: _user_id,
                        date: _date,
                        validation: false,
                        active: false
                    })

                } else
                    return { day: null, day_string: _date };
            } else {
                for (let i = 1; i < coll.length; i++) {
                    //await deleteDay(coll[i].id);
                }

                return { day: coll[0], day_string: _date };
            }
        }).catch((e) => {
            console.error("Erreur : dayActions - createOrGetDayByDate", e);
            throw e;
        });
    }).catch((e) => {
        console.error("Erreur : dayActions - createOrGetDayByDate", e);
        throw e;
    });
}
